import React, { Fragment } from 'react';
import { Icon } from '@blueprintjs/core'
import { translate } from 'utlis/translations/i18n';



const ManualChoice = ({ session, instance, onVote, votedFor, generalContext, currentContext, onSwitchResource }) => {

    // const { session, instance, onVote, votedFor } = this.props;
    const { data } = session;
    const { sequences = [] } = data;
    const { currentSequence } = instance;
    const sequence = sequences[currentSequence];
    const resources = sequence.resources

    const handleSwitchResource = index => {

        onSwitchResource(index);
    };

    return (
        <Fragment>
            <div className="context text-center">
                {generalContext && (<>
                    {translate('generalContext')}: <br />
                    {generalContext} <br /><br />
                </>)}
                {currentContext && (<>
                    {translate('sequenceContext')}: <br />
                    {currentContext} <br /><br />
                </>)}

            </div>
            <div className="resource-switcher-CM">
                <button
                    className={instance.currentSequenceResource >= 1 ? "resource-button" : "unActiveButton"}
                    onClick={instance.currentSequenceResource >= 1 ? () => handleSwitchResource(instance.currentSequenceResource - 1) : () => console.log('test')}
                >
                    <Icon icon='arrow-left'
                        iconSize={35}
                        className='playerButton'
                    />
                </button>

                <div className="">
                    <div
                        className={votedFor === (sequence && sequence.resources && sequence.resources[instance.currentSequenceResource] && sequence.resources[instance.currentSequenceResource].id) ? 'selectResourceCM selectedVoteButton' : 'selectResourceCM'}
                        onClick={() => onVote(sequence.resources[instance.currentSequenceResource].id)}>
                        {translate('select')}
                    </div>
                    <div style={{ fontSize: "large" }}>Image {instance.currentSequenceResource + 1} {translate('of')} {resources.length}</div>
                </div>

                <button
                    className={instance.currentSequenceResource < (resources.length - 1) ? "resource-button" : "unActiveButton"}
                    onClick={instance.currentSequenceResource < (resources.length - 1) ? () => handleSwitchResource(instance.currentSequenceResource + 1) : () => console.log('test')}
                >
                    <Icon icon='arrow-right'
                        iconSize={35}
                        className='playerButton'
                    />
                </button>
            </div>
        </Fragment>
    );
}

export default ManualChoice;